module.exports = [{
      plugin: require('/tmp/17998e0a/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
